import { Layer, Source } from "react-map-gl/mapbox"

interface PPRILayerProps {
  opacity?: number
}

export const PPRILayer = ({ opacity = 0.7 }: PPRILayerProps) => {
  return (
    <>
      <Source
        id="raster-ppri1"
        type="raster"
        tiles={[
          "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=PPRN_COMMUNE_RISQINOND&STYLES=&SRS=EPSG%3A3857&CRS=EPSG%3A3857&TILED=false&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
        ]}
        tileSize={256}
        maxzoom={15}
      >
        <Layer id="raster-ppri1" type="raster" source="raster-ppri1" paint={{ "raster-opacity": opacity }} />
      </Source>
      <Source
        id="raster-ppri2"
        type="raster"
        tiles={[
          "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=PPRN_COMMUNE_RISQSUBM&STYLES=&SRS=EPSG%3A3857&CRS=EPSG%3A3857&TILED=false&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
        ]}
        tileSize={256}
        maxzoom={15}
      >
        <Layer id="raster-ppri2" type="raster" source="raster-ppri2" paint={{ "raster-opacity": opacity }} />
      </Source>
    </>
  )
}
